type PromiseResolveType = {
    width: number;
    height: number;
    naturalWidth: number;
    naturalHeight: number;
};

export async function getOriginalImageDimensions(src: string) {
    return new Promise<PromiseResolveType>((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            // Use setTimeout to defer execution of the resolve callback
            // This ensures that the browser has finished updating image properties
            // Setting a timeout of 0 milliseconds means the callback will be executed
            // as soon as the current event loop iteration completes
            setTimeout(() => {
                resolve({
                    width: img.width,
                    height: img.height,
                    naturalWidth: img.naturalWidth,
                    naturalHeight: img.naturalHeight
                });
            }, 0);
        };
        img.onerror = () => reject(new Error('Error loading image'));
        img.src = src;
    });
}
